module.exports = __webpack_public_path__ + "static/media/1_Pokana_20170631.04937c0f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/1_Pokana_20170631.pdf
// module id = 150
// module chunks = 0